import './ItemList.component.scss';

import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { getAssetUrl } from '../../../utils/GetAssetUrl';
import {
  EDefaultWishList,
  EWishlistVisibility,
  TWishlistVisibility,
} from '../../../domain/wish.interface';

export enum EItemList {
  WISHLIST = 'WISHLIST',
  GROUP = 'GROUP',
  OTHER = 'OTHER',
}

interface ItemListProps {
  name: string;
  type: EItemList;
  photoUrl?: string;
  isDefault?: boolean;
  visibility?: TWishlistVisibility;
  highlight?: boolean;
  editFunction?: any;
  deleteFunction?: any;
  icon?: IconName;
  buttons?: { func?: any; icon: IconName }[];
}

export function ItemListComponent(props: ItemListProps) {
  const {
    name: propsName,
    type,
    isDefault,
    visibility,
    highlight,
    editFunction,
    deleteFunction,
    photoUrl,
    icon,
    buttons,
  } = props;

  const name =
    isDefault && propsName === EDefaultWishList.MY_WISHES ? (
      <FormattedMessage id='pages.wishlist_catalogue.default_list_1'></FormattedMessage>
    ) : isDefault && propsName === EDefaultWishList.RECOMMENDED ? (
      <FormattedMessage id='pages.wishlist_catalogue.default_list_2'></FormattedMessage>
    ) : (
      propsName
    );

  return (
    <li
      className={`itemlist-component-container list-group-item d-flex align-items-center justify-content-between ${
        highlight ? 'highlighted' : ''
      }`}
    >
      <div className='itemlist-component-left-container d-flex align-items-center justify-content-start'>
        <div className='image-container'>
          {!!photoUrl ||
          type === EItemList.WISHLIST ||
          type === EItemList.GROUP ? (
            <div
              style={{
                backgroundImage: !!photoUrl
                  ? `url(${getAssetUrl.images(photoUrl)})`
                  : type === EItemList.WISHLIST
                  ? `url(${getAssetUrl.icons('VARITA_AMARILLA.svg')})`
                  : `url(${getAssetUrl.icons('GRUPOS_siluette.svg')})`,
                backgroundSize: !!photoUrl ? '100%' : '75%',
              }}
            />
          ) : (
            <div className='icon-container d-flex justify-container-center align-items-center'>
              <FontAwesomeIcon icon={icon as IconName} />
            </div>
          )}
        </div>
        <div className='text-container'>
          <h4>{name}</h4>
          {type === EItemList.WISHLIST && (
            <span className='public-text font-weight-light text-primary'>
              <FormattedMessage
                id={`common.${
                  visibility === EWishlistVisibility.PUBLIC
                    ? 'public_list'
                    : 'private_list'
                }`}
              />
            </span>
          )}
        </div>
      </div>
      <div className='itemlist-component-right-container'>
        {!!editFunction && (
          <button className='btn edit' onClick={editFunction}>
            <FontAwesomeIcon className='icon' icon='edit' />
          </button>
        )}
        {!!deleteFunction && (
          <button className='btn delete' onClick={deleteFunction}>
            <FontAwesomeIcon className='icon' icon='trash' />
          </button>
        )}
        {!!buttons &&
          !!buttons.length &&
          buttons.map((btn: any, idx: number) => (
            <button
              key={`btn-${idx}`}
              className='btn'
              onClick={!!btn.func ? btn.func : null}
            >
              <FontAwesomeIcon className='icon' icon={btn.icon} />
            </button>
          ))}
      </div>
    </li>
  );
}
